window.App = {
    W: $(window),
    D: $(document),
    H: $('html'),
    B: $('body')
};


// WEBPACK FOOTER //
// ./_src/js/app.js